import { Component, OnDestroy } from '@angular/core';
import { NavController, AlertController, ToastController, ViewController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { provider } from '../../../providers/provider';
import { HttpClient } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import { Events } from 'ionic-angular';
import { Subject } from 'rxjs';
import { CustomizerProvider } from '../../../providers/customizer/customizer';

@Component({
  selector: 'page-addAddress',
  templateUrl: 'addAddress.html'
})
export class AddAddressPage implements OnDestroy {
  private form: FormGroup;
  city = { name: '', cap: '', province: '', provinceInitials: '', region: '', country: '' };
  customerInfo = {};
  regions = ['Abruzzo', 'Basilicata', 'Calabria', 'Campania', 'Emilia-Romagna', 'Fruli-Venezia Giulia', 'Lazio', 'Liguria', 'Lombardia', 'Marche', 'Molise', 'Piemonte', 'Puglia', 'Sardegna', 'Sicilia', 'Toscana', 'Trentino-Alto Adige', 'Umbria', 'Valle d\'Aosta', 'Veneto'];
  provinces;
  cities;
  url: string;
  items;
  selected = false;
  results;
  item;
  private _onDestroy = new Subject();

  constructor(public navCtrl: NavController,
    public translateService: TranslateService,
    public storage: Storage,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public provider: provider,
    public viewCtrl: ViewController,
    private formBuilder: FormBuilder,
    public events: Events,
    public http: HttpClient,
    public customizer: CustomizerProvider) {

    this.url = provider.getUrl();

    this.storage.get('customer').then((customer) => {
      this.customerInfo = JSON.parse(customer);
    });

    this.items = JSON.parse(sessionStorage.getItem('comuni'));

    this.form = this.formBuilder.group({
      country: ['', Validators.required],
      region: ['', Validators.required],
      province: ['', Validators.required],
      city: ['', Validators.required],
      address: ['', Validators.required],
      number: ['', Validators.required],
      zipCode: ['', Validators.required],
      intercomName: ['', Validators.required]
    });

  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  initializeItems() {
    return this.items;
  }

  getItems(ev: any) {
    this.initializeItems();
    const val = ev.target.value;
  
    if (val && val.trim() != '') {
      this.results = this.items.filter((item) => {
        return (item.name).toLowerCase().startsWith(val.toLowerCase());
      })
    }
  }

  select(item) {
    this.selected = true;
    this.item = item;
  }

  
  add() {
    // avoid wrong text
    if (!this.selected)
      return
    // process 
    this.translateService.get(['E9999', 'SUCCESS']).takeUntil(this._onDestroy).subscribe(msg => {
      let form = this.form.value;
      // form.favorite = false;
      form.id = uuidv4();
      let account = {
        addresses: (<any>this.customerInfo).addresses,
        email: (<any>this.customerInfo).email,
        firstName: (<any>this.customerInfo).firstName,
        lastName: (<any>this.customerInfo).lastName,
        id: (<any>this.customerInfo)._id
      };
      account.addresses.push(form);
      this.provider.edit(account).takeUntil(this._onDestroy).subscribe(() => {
        this.provider.getCustomer(account.id).takeUntil(this._onDestroy).subscribe(data => {
          let toast = this.toastCtrl.create({
            message: msg.SUCCESS,
            duration: 3000,
            position: 'middle'
          });
          toast.present();
          // save customer and notify caller
          this.storage.set('customer', (<any>data)._body).then((user) => {
            this.events.publish('user:updated', (<any>data)._body);
          });
          this.navCtrl.pop();
        }, err => {
          let toast = this.toastCtrl.create({
            message: msg.E9999,
            duration: 3000,
            position: 'middle'
          });
          toast.present();
        });
      }, err => {
        let toast = this.toastCtrl.create({
          message: msg.E9999,
          duration: 3000,
          position: 'middle'
        });
        toast.present();
      });


    });

  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/addAddress/addAddress.ts